import { render, staticRenderFns } from "./researchMain.vue?vue&type=template&id=6ab13159&scoped=true"
import script from "./researchMain.vue?vue&type=script&lang=js"
export * from "./researchMain.vue?vue&type=script&lang=js"
import style0 from "./researchMain.vue?vue&type=style&index=0&id=6ab13159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab13159",
  null
  
)

export default component.exports